import { HStack, Input, Heading } from "@chakra-ui/react"
import { TbInputSearch } from "react-icons/tb"

type SearchInputProps = {
  value: string
  onChange: (value: string) => void
}

export default function SearchInput({ value, onChange }: SearchInputProps) {
  return (
    <HStack gap={2}>
      <Heading size="lg">
        <TbInputSearch />
      </Heading>
      <Input
        placeholder="리포트 이름 검색"
        size="sm"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        maxW="200px"
      />
    </HStack>
  )
}
